import React from "react";
import OptionCard from "./OptionCard";

const VideoChatView = ({ series }: { series: any }) => (
  <div className="space-y-4">
    <video
      controls
      src={series.question.videoUrl}
      className="w-full h-[18rem] mt-2 rounded-md"
    />
    <div className="flex gap-3 overflow-x-auto pb-2">
      {series.options.map((opt: any) => (
        <OptionCard
          key={opt.id}
          option={opt}
          isCorrect={series.answer.includes(opt.id)}
        />
      ))}
    </div>
  </div>
);

export default VideoChatView;
